//@ts-nocheck
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDDropzone from "components/MDDropzone";
import React, { useEffect, useState } from "react";
import { useStoreActions, useStoreState } from "easy-peasy";
import MDSnackbar from "../../../../components/MDSnackbar";
import MDProgress from "components/MDProgress";
import FullPageLoader from "../../../../components/Loader/FullPage";
import { useParams } from "react-router-dom";
import SendEmailComponent from "pages/applications/components/SendDocumentEmailModel";
import CombinePDFModel from "pages/applications/components/CombinePDFModel";
import GenerateDocumentModel from "pages/applications/components/GenerateDocumentModel";

const TopBar = ({ appId, selectedFiles, setSelectedFiles, categories, refreshDocs }) => {
  const uploadFile = useStoreActions((actions: any) => actions.fileUploads.uploadFile);
  const downloadFile = useStoreActions((actions: any) => actions.fileUploads.downloadSingleFile);
  const downloadSelectedDocuments = useStoreActions(
    (actions: any) => actions.fileUploads.downloadSelectedDocuments
  );

  const { id } = useParams();

  const [alert, setAlert] = useState<{
    type: "success" | "error" | "warning" | null;
    message: any;
    timeOut: number;
  } | null>(null);
  const [uploadingFiles, setUploadingFiles] = useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSendEmail, setShowEmail] = useState(false);
  const [showCombinePdf, setShowCombinePdf] = useState(false);
  const [showGenerateDocument, setShowGenerateDocument] = useState(false);
  const storeLoading = useStoreState((state: any) => state.docGen.loading);

  if (!appId) {
    appId = id;
  }

  const handleFileDownload = () => {
    if (selectedFiles.length === 0) {
      setAlert({
        type: "warning",
        message: "Please Select at Least one Document",
      });
      return;
    } else if (selectedFiles.length == 1) {
      downloadFile(selectedFiles[0]);
    } else {
      downloadSelectedDocuments({ mediaAttachmentIds: selectedFiles.map((file) => file.id) });
    }
  };

  const onClose = () => {
    setShowEmail(false);
  };

  const handleFileDrop = async (files: File[]) => {
    const failedFiles: string[] = [];
    let successFiles = 0;
    const totalFiles = files.length;

    if (totalFiles === 0) {
      setAlert({
        type: "error",
        message: "No valid files present. Max Upload size is 40 files.",
      });
      return;
    }

    for (const file of files) {
      let UUID = Math.random() * 9000 + "" + Date.now();

      try {
        await uploadFile({
          file,
          tenantId: 1,
          mediaToken: UUID,
          dealApplicationId: appId,
          description: "",
          category: "Miscellaneous",
        });

        successFiles++;
      } catch (error) {
        failedFiles.push(file.name);
      }
    }

    if (failedFiles.length > 0) {
      setAlert({
        type: "error",
        message: `Error uploading the following files: ${failedFiles.join(", ")}`,
      });
    } else if (successFiles === totalFiles) {
      setAlert({
        type: "success",
        message: "All files uploaded successfully!",
      });
    } else {
      setAlert({
        type: "warning",
        message: "Some files failed to upload.",
      });
    }

    setUploadingFiles([]);
    refreshDocs(appId);
  };

  const onRemoveFile = (fileId) => {
    setSelectedFiles((prevState) => prevState.filter((selected) => selected !== fileId));
  };

  const refreshAll = () => {
    refreshDocs(appId);
  };

  return (
    <MDBox display="flex" justifyContent="flex-start" alignItems="center" width="100%" p={2}>
      {(isSubmitting || storeLoading) && <FullPageLoader />}

      <MDBox display="flex" alignItems="center" gap={2}>
        {uploadingFiles.length > 0 ? (
          <MDProgress value={100} variant="contained" label />
        ) : (
          <MDDropzone
            title={"Drag and Drop Files Here, or Click to Upload."}
            onDropFile={handleFileDrop}
          />
        )}
      </MDBox>

      {alert && (
        <MDSnackbar
          color={alert?.type === "success" ? "success" : "error"}
          icon="notifications"
          title={alert?.type === "success" ? "Success" : "Error"}
          content={alert?.message}
          dateTime=""
          autoHideDuration={alert?.timeOut || 5000}
          open={alert !== null}
          close={() => setAlert(null)}
        />
      )}

      <MDBox marginLeft={2} display="flex" alignItems="center" gap={2}>
        {selectedFiles.length > 0 && (
          <MDButton variant="gradient" color="primary" onClick={handleFileDownload}>
            Download
          </MDButton>
        )}

        {selectedFiles.length > 0 && (
          <MDButton variant="gradient" color="primary" onClick={() => setShowEmail(true)}>
            Email
          </MDButton>
        )}

        <MDButton variant="gradient" color="primary" onClick={() => setShowGenerateDocument(true)}>
          Generate Document
        </MDButton>

        {selectedFiles.length > 1 &&
          selectedFiles?.every((file) => file?.name?.endsWith(".pdf")) && (
            <MDButton variant="gradient" color="primary" onClick={() => setShowCombinePdf(true)}>
              Combine PDFs
            </MDButton>
          )}
      </MDBox>

      <SendEmailComponent
        showModal={showSendEmail}
        onClose={onClose}
        dealApplicationId={id}
        selectedDocuments={selectedFiles}
      />

      <CombinePDFModel
        selectedFiles={selectedFiles}
        showModal={showCombinePdf}
        hideModal={() => setShowCombinePdf(false)}
        applicationId={id}
        categories={categories}
        setSelectedFiles={setSelectedFiles}
        setIsRefreshing={setIsSubmitting}
        onRemoveFile={onRemoveFile}
        refreshDocuments={refreshAll}
        setAlert={setAlert}
      />

      <GenerateDocumentModel
        id={appId}
        selectedFiles={selectedFiles}
        showModal={showGenerateDocument}
        hideModal={() => setShowGenerateDocument(false)}
        applicationId={id}
        categories={categories}
        setSelectedFiles={setSelectedFiles}
        setIsRefreshing={setIsSubmitting}
        onRemoveFile={onRemoveFile}
        refreshDocuments={refreshAll}
        setAlert={setAlert}
      />
    </MDBox>
  );
};

export default TopBar;
